module.exports = __webpack_public_path__ + "static/media/banner-img.baad99e9.png";